import { createApp } from 'vue';
import App from './App.vue';

import '@/helpers/form-validation';
import '@itx-data/ui-helpers';

// Se usa el build "external-css" de vue-easy-lightbox: el build por defecto
// inyecta su CSS con un <style> en document.head, lo que obligaria a
// 'unsafe-inline' en la directiva style-src de la CSP.
import Lightbox from 'vue-easy-lightbox/dist/external-css/vue-easy-lightbox.esm.min.js';
import 'vue-easy-lightbox/dist/external-css/vue-easy-lightbox.css';
import router, { routes } from './router';

import { installLibrary } from '@itx-data/edc-components';
import { installIcons } from '@itx-data/ui-icons';
import { createPinia } from 'pinia';
import { register } from 'swiper/element/bundle';

import '@/assets/scss/app.scss';
import '@itx-data/edc-components/style.css';
import '@itx-data/edc-grid';
import { filterRolesPermissions } from '@itx-data/ui-helpers';
import i18n from '@/locales/i18n';

const pinia = createPinia();
export const app = createApp(App).use(pinia);

filterRolesPermissions<string>([], router, routes);

app.use(Lightbox).use(router).use(installIcons).use(installLibrary).use(i18n).mount('#app');

register();
